
import HeartTick from "../../../assets/duotone/HeartTick.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function HeartTickIcon({ className, dataTestid = "HeartTickIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <HeartTick data-testid={dataTestid} className={classes} {...rest} />
  );
}
